var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col col-12"},[_c('div',{staticClass:"body form-wrap"},[_vm._t("body")],2),_vm._v(" "),_c('div',{staticClass:"main-gradient"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }